module.exports = __webpack_public_path__ + "img/bg99.7367fd0b.png";